export enum WebSocketsRoomActions {
    JoinRoom = 'joinRoom',
    LeaveRoom = 'leaveRoom',
}
